import MessageBox from './main.js'
export default {
  install: MessageBox
}



// WEBPACK FOOTER //
// ./src/ui/components/messagebox/index.js